module.exports = __webpack_public_path__ + "static/img/2997_phase_function_Paper_PointsHejduk_Prediction.557d49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2997_phase_function_Paper_PointsHejduk_Prediction.png
// module id = U/+c
// module chunks = 0